import Colors from "../../../../../general/constants/colors";
import BreakPoints from "../../../../../general/constants/breakPoints";

export const ListItemTextStyles = {
	'&:hover': {
		color: Colors.GREEN
	},
	[`@media (max-width: ${BreakPoints.FHD_1919}px)`]: {
		fontSize: "14px",
	},
}